<div class="vspeers-header-section">
  <div class="vspeers-header-left-section">
    <div class="vspeers-filter">
      <div class="vspeers-ticker">
        <label class="vspeers-filter-label">
          Peers
        </label>
        <app-ticker-search
          [tickers]="selectedTickerIds"
          [onScreen]="true"
          [isComp]="true"
          (onSearchedTickerUpdate)="handleSearchTickerSelection($event)"
          [hasSearchIcon]="true"
          [suggestedTickers]="suggestedPeers"
          placeholder="&nbsp;Add Peers"
          maxSelectedTickerCount="50"
          [disabled]="
            !isWatchListAndRecentCompDataReady ||
            isUserSettingsInProgress ||
            !isMetaReady
          "
        ></app-ticker-search>
        <button
          nz-button
          class="on-screen-search__edit-btn"
          (click)="handleEditTickerClick()"
        >
          Edit
        </button>
      </div>
    </div>
    <div class="vspeers-filter">
      <va-currency-select
        size="small"
        selectWidth="78"
        labelPlacement="top"
        [bottomBorderView]="true"
        [selectedCurrency]="state ? state.currency : undefined"
        [apiEP]="apiEP"
        apiUrl="/api/get_available_currencies"
        (onChange)="updateCurrency($event)"
        [disabled]="isUserSettingsInProgress || !isMetaReady"
      ></va-currency-select>
    </div>
    <div class="vspeers-price-performance">
      <app-single-select-dropdown
        *ngIf="pricePerformanceAvailable"
        label="Price performance period"
        width="150px"
        [items]="pricePerformanceOptions"
        [selectedItem]="state ? state.price_performance : undefined"
        (callback)="onPricePerformanceChange($event)"
        [disabled]="isUserSettingsInProgress || !isMetaReady"
      >
      </app-single-select-dropdown>
    </div>
  </div>
  <div class="vspeers-header-right-section">
    <va-button
      btnType="outline"
      size="medium"
      (onClick)="hanldeColumnPickerClick()"
      title="Column Picker"
      [isDisabled]="isTprColumnDetailsSaveApiInProgress || !isMetaReady"
      >Column Picker</va-button
    >
    <app-export-to-excel-dropdown
      class="export-button"
      [(isPopoverVisible)]="isExportPopoverVisible"
      [disabled]="isTprColumnDetailsSaveApiInProgress || !isMetaReady"
      [optionList]="excelToExportDropdownOptions"
      [isExportInProgress]="isExportInProgress"
      (onListItemClick)="handleETEListItemClick($event)"
    ></app-export-to-excel-dropdown>
  </div>
</div>

<app-column-picker-modal
  [data]="columnPickerData"
  [isModalVisible]="isColumnPickerModalVisible"
  (onApply)="hanldeColumnPickerApplyClick($event)"
  (onReset)="handleColumnPickerResetClick()"
  (onCancel)="handleColumnPickerCancelClick()"
  (onDrag)="handleColumnDrag($event)"
></app-column-picker-modal>
